// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2cXq95-TO9CPV34JEjtdQ-{padding-bottom:5rem;margin-top:3.2rem}@media only screen and (min-width:768px){._2cXq95-TO9CPV34JEjtdQ-{padding-bottom:0}}._3uYl1FsT-R_3QGi9xOVbUs{width:6.4rem;display:block;margin:0 auto 2.4rem}@media only screen and (min-width:992px){._3uYl1FsT-R_3QGi9xOVbUs{width:8rem}}._2GKLH9j3Pa1wGMII3Gp4aI{display:flex;flex-direction:column;padding:1.6rem 0}._333QWEteUN9im_rwuYUBTv{margin-bottom:2.4rem}._1woKfuM2LWbvgN1VNDa-2K{margin-bottom:1.2rem}._2ThT5xtr6ksHuE9ZABhHd5{margin-bottom:1.6rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_2cXq95-TO9CPV34JEjtdQ-",
	"image": "_3uYl1FsT-R_3QGi9xOVbUs",
	"actions": "_2GKLH9j3Pa1wGMII3Gp4aI",
	"buttonLink": "_333QWEteUN9im_rwuYUBTv",
	"button": "_1woKfuM2LWbvgN1VNDa-2K",
	"text": "_2ThT5xtr6ksHuE9ZABhHd5"
};
module.exports = ___CSS_LOADER_EXPORT___;
